import React, { type ReactNode } from "react";
import { Box } from "@chakra-ui/react";
import { type TypewriterProps } from "ui/typewriter";
import { CopilotTypewriter } from "components/copilot-typewriter";

function ContainerBorder({ children }: { children: ReactNode }) {
  return (
    <Box bg="white" border="1px" borderColor="purple.100" borderRadius="15px" w="100%" overflow="hidden">
      <Box
        bg="linear-gradient(90deg, rgba(189, 133, 251, 0.12), rgba(141, 219, 233, 0.12) 40%)"
        boxSize="100%"
        p={{ base: 3, md: 4, xl: 6 }}
      >
        {children}
      </Box>
    </Box>
  );
}

export function Prompt(props: TypewriterProps) {
  return (
    <ContainerBorder>
      <CopilotTypewriter containerProps={{ boxShadow: "0px 0px 0px 4.5px #F2E7FE" }} {...props} />
    </ContainerBorder>
  );
}
